import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/_stacktrace/customers/$customerId/_layout/profile/')({});